export const ARCHIVE_DELETE_WAIT_DAYS = 7;

export function isTemplateArchived(template) {
  return Boolean(template?.is_archived);
}

export function parseArchivedAt(archivedAt) {
  if (!archivedAt) return null;
  const date = archivedAt instanceof Date ? archivedAt : new Date(archivedAt);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isTemplateDeletable(template, retentionDays) {
  if (!isTemplateArchived(template)) return false;

  const waitDays = retentionDays ?? template?.archive_delete_wait_days ?? ARCHIVE_DELETE_WAIT_DAYS;
  const archivedAt = parseArchivedAt(template?.archived_at);
  if (!archivedAt) return false;

  const eligibleAt = new Date(archivedAt);
  eligibleAt.setDate(eligibleAt.getDate() + waitDays);
  return Date.now() >= eligibleAt.getTime();
}

export function getDaysUntilDeletable(template, retentionDays) {
  if (!isTemplateArchived(template)) return null;

  const waitDays = retentionDays ?? template?.archive_delete_wait_days ?? ARCHIVE_DELETE_WAIT_DAYS;
  const archivedAt = parseArchivedAt(template?.archived_at);
  if (!archivedAt) return waitDays;

  const eligibleAt = new Date(archivedAt);
  eligibleAt.setDate(eligibleAt.getDate() + waitDays);
  const diffMs = eligibleAt.getTime() - Date.now();
  if (diffMs <= 0) return 0;

  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function getTemplateDeleteBlockedMessage(template, retentionDays) {
  if (!isTemplateArchived(template)) {
    return 'Archive the template before deleting.';
  }

  const waitDays = retentionDays ?? template?.archive_delete_wait_days ?? ARCHIVE_DELETE_WAIT_DAYS;
  const daysLeft = getDaysUntilDeletable(template, waitDays);
  if (daysLeft > 0) {
    return `Delete will be available in ${daysLeft} day(s). Templates must stay archived for ${waitDays} days.`;
  }

  return '';
}

export function getArchiveDeleteLabel(template, retentionDays) {
  if (!isTemplateArchived(template)) return null;
  const waitDays = retentionDays ?? template?.archive_delete_wait_days ?? ARCHIVE_DELETE_WAIT_DAYS;
  const daysLeft = getDaysUntilDeletable(template, waitDays);
  if (daysLeft <= 0) return 'Ready to delete';
  return `Delete in ${daysLeft} day(s)`;
}
